import { combineReducers } from "redux"
import GLOBAL from "./global"
import user from "./user"
import customer from "./customer"
import audit from "./audit"
import scriptLibrary from "./scriptLibrary"

export default combineReducers({
  global: GLOBAL,
  user,
  customer,
  audit,
  scriptLibrary,
})
